<template>
    <v-card>
        <v-card-title style="position:fixed; z-index:9999; background:white; width:96.5%; border-bottom:1px solid rgba(0,0,0,0.2); font-size:32px; padding-bottom:25px;">
        <span><b>Nouvelle Facture Magasinage</b></span> 
        <!--<v-spacer></v-spacer>
        <v-col class="d-flex" cols="12" sm="2">
            <v-select
                hide-details
                label="Type Facture"
                :items="['Facture Standard', 'Facture D/A']"
                @change="changeType"
                v-model="typeFacture"
            >
            </v-select>
        </v-col>-->
        </v-card-title>
        <v-row style="position:relative; width:100%; height:100%; top:100px;">
            <v-col cols="12" md="9" style="border-right:1px solid rgba(0,0,0,0.2); height:500px; overflow-y:scroll;">
                 <span style="color:gray; margin-left:25px;" class="text-left">Veuillez Selectionner un avis pour pouvoir continuer.</span>
                <v-form v-model="valid">
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-autocomplete
                                label="Référence Dossier"
                                outlined
                                :items="dossierList"
                                item-text="numdossier"
                                item-value="id"
                                clearable
                                v-model="currentDossierId"
                                :disabled="currentDossier !== null"
                                hide-details
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-autocomplete
                                    v-model="avisId"
                                    hide-details
                                    :items="listAvis"
                                    :disabled="currentAvis !== null"
                                    item-text="num_avis"
                                    item-value="id"
                                    clearable
                                    outlined
                                    label="Avis relatif"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                label="Libellé"
                                v-model="titreFacture"
                                :rules="infoRules"
                                outlined
                                required
                                hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                label="Date"
                                outlined
                                required
                                :value="todayDate"
                                hide-details
                                disabled
                                ></v-text-field>
                            </v-col>
                            </v-row>    
                        </v-container>
                    </v-card-text>
                    <template v-if="avisId > 0">
                        <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                        <v-card-title>
                            <span style="font-size:28px;"><b>Informations Générales</b></span>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <template v-if="currentDossierVar !== null">
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Type Dossier"
                                        outlined
                                        :disabled="currentDossierVar !== null"
                                        v-model="currentDossierVar.type"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Classe Dossier"
                                        outlined
                                        :disabled="currentDossierVar !== null"
                                        v-model="currentDossierVar.classe"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <template v-if="currentDossierVar.classe !== 'Aérien'">
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Escale"
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.escale"
                                            outlined
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Voyage"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.voyage"
                                            required
                                            hide-details
                                            :value="currentAvis"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Consignataire"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.consig"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Armateur"
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.armateur"
                                            outlined
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Navire"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.navire"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Date d'embarquement"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.from_date"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Port d'embarquement"
                                            outlined
                                            required
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.port_from"
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Date de débarquement"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.to_date"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Port de débarquement"
                                            outlined
                                            required
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.port_to"
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Type Conteneur"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.conteneur_type"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="N° Conteneur"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.conteneur_num"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="N° Escale Magasin"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.num_escale_magasin"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                    </template>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe !== 'Aérien' && currentFactureTmp.id !== null">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="B/L"
                                        v-model="currentFactureTmp.bl"
                                        outlined
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe === 'Groupage'">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="Bureau"
                                        v-model="currentFactureTmp.bureau"
                                        outlined
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe === 'Groupage'">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="Valeur"
                                        v-model="currentFactureTmp.valeur"
                                        outlined
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe === 'Groupage'">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="Code Magasin"
                                        v-model="currentFactureTmp.code_magasin"
                                        outlined
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="P/C"
                                        :rules="infoRules"
                                        outlined
                                        v-model="currentFactureTmp.pc"
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-autocomplete
                                        label="Correspondant"
                                        outlined
                                        :rules="infoRules"
                                        v-model="currentFactureTmp.correspondant_id"
                                        :items="correspondantList"
                                        :disabled="currentFactureTmp.id !== null"
                                        item-text="nom"
                                        item-value="id"
                                        :value="currentFactureTmp.correspondant_id"
                                        required
                                        hide-details
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Terme"
                                        :rules="infoRules"
                                        outlined
                                        v-model="currentFactureTmp.terme"
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Fournisseur"
                                        :rules="infoRules"
                                        outlined
                                        v-model="currentFactureTmp.fournisseur"
                                        :disabled="currentFactureTmp.id !== null"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>      
                                    </template>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-autocomplete
                                        label="Agent Commercial"
                                        outlined
                                        :rules="infoRules"
                                        v-model="currentFactureTmp.agent_id"
                                        :items="agentList"
                                        :disabled="currentFactureTmp.id !== null"
                                        item-text="nom"
                                        item-value="id"
                                        :value="currentFactureTmp.agent_id"
                                        required
                                        hide-details
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-autocomplete
                                        label="Client"
                                        :rules="infoRules"
                                        outlined
                                        v-model="currentFactureTmp.client_id"
                                        :items="listClient"
                                        :disabled="currentFactureTmp.id !== null"
                                        item-text="fullname"
                                        item-value="id"
                                        :value="currentFactureTmp.client_id"
                                        required
                                        hide-details
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Date Dépotage"
                                        outlined
                                        :disabled="currentDossierVar !== null"
                                        :value="currentDossierVar.date_depotage | formatDate"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-menu
                                            ref="menu_enlevement"
                                            v-model="menu_enlevement"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="currentFactureTmp.date_enlevement | formatDate"
                                                label="Date Enlèvement"
                                                readonly
                                                outlined
                                                hide-details
                                                :rules="magasinRules"
                                                required
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker @change="change_jrs" v-model="currentFactureTmp.date_enlevement" @input="menu_enlevement = false" :min="currentDossierVar.date_depotage" no-title scrollable></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Nombre De Jours"
                                            outlined
                                            v-model="nb_jours"
                                            disabled
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-select
                                            label="Calcul Magasinage En Fonction de"
                                            :items='["Poids", "Volume"]'
                                            outlined
                                            v-model="calcul_en_fc"
                                            @change="typeCalculChange"
                                            required
                                            :rules="magasinRules"
                                            hide-details
                                        >    
                                        </v-select>
                                    </v-col>    
                                    
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Durée Période 1"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            type="Number"
                                            v-model="period1"
                                            @change="calculReste"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="PUHT Période 1"
                                            :rules="magasinRules"
                                            required
                                            outlined
                                            type="Number"
                                            v-model="prix_period1"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Franchise"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            type="Number"
                                            @change="calculReste"
                                            v-model="franchise"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Valeur"
                                            outlined
                                            required
                                            v-model="currentFactureTmp.type_calcul_value"
                                            disabled
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Durée Période 2"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            v-model="period2"
                                            @change="calculReste"
                                            hide-details
                                            type="Number"
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="PUHT Période 2"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            v-model="prix_period2"
                                            hide-details
                                            type="Number"
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"></v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Durée Hors Période"
                                            outlined
                                            type="Number"
                                            required
                                            disabled
                                            v-model="hors_periode"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="PUHT Hors Période"
                                            outlined
                                            type="Number"
                                            :rules="magasinRules"
                                            v-model="prix_hors_periode"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                        <v-card-title style="font-size:28px;"><b>Marchandises</b></v-card-title>
                        <v-card-text>
                            <v-container fluid>
                                <v-row v-if="currentDossierVar !== null && avisId === 0">
                                    <v-col cols="12" sm="11" v-if="currentDossierVar.classe == 'Complet'">
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <v-autocomplete
                                                v-model=marchandiseTmp.cont_type
                                                :items="conteneurList"
                                                item-text=titre
                                                outlined
                                                dense
                                                label="Type Conteneur"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model=marchandiseTmp.cont_numero
                                                    label="Numero Conteneur"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model=marchandiseTmp.rub
                                                label="Rub."
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model=marchandiseTmp.colis
                                                    label="Colis"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model=marchandiseTmp.description
                                                label="Description de la marchandise"
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model=marchandiseTmp.poids
                                                    label="Poids (Kg)"
                                                    type="number"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="11" v-if="currentDossierVar.classe == 'Groupage'">
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model=marchandiseTmp.rub
                                                label="Rub."
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model=marchandiseTmp.colis
                                                    label="Colis"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model=marchandiseTmp.description
                                                label="Description de la marchandise"
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model=marchandiseTmp.poids
                                                    label="Poids (Kg)"
                                                    type="number"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model=marchandiseTmp.volume
                                                    label="Volume"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="1" class="text-right pt-6">
                                        <v-btn  color="primary" fab @click="addMarchandise"><v-icon>mdi-arrow-down</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="12">
                                        <v-simple-table class="text-left" v-if="currentDossierVar !== null" dense>
                                            <template v-slot:default>
                                            <thead>
                                                <tr>
                                                <th class="text-left">Rub.</th>
                                                <th class="text-left">Colis.</th>
                                                <th class="text-left" v-if="currentDossierVar.classe !== 'Aérien' && currentDossierVar.classe !== 'Groupage'">Cont.N°</th>
                                                <th class="text-left" v-if="currentDossierVar.classe !== 'Aérien' && currentDossierVar.classe !== 'Groupage'">Cont.Type</th>
                                                <th class="text-left">Description</th>
                                                <th class="text-left">Poids</th>
                                                <th class="text-left" v-if="currentDossierVar.classe === 'Groupage'">Volume</th>
                                                <th v-if="avisId === 0">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(marchandise,index) in currentFactureTmp.marchandises" v-bind:key="index">
                                                    <td>{{marchandise.rub}}</td>
                                                    <td>{{marchandise.colis}}</td>
                                                    <td v-if="currentDossierVar.classe !== 'Aérien' && currentDossierVar.classe !== 'Groupage'">{{marchandise.cont_numero}}</td>
                                                    <td v-if="currentDossierVar.classe !== 'Aérien' && currentDossierVar.classe !== 'Groupage'">{{marchandise.cont_type}}</td>
                                                    <td>{{marchandise.description}}</td>
                                                    <td>{{marchandise.poids}} Kg</td>
                                                    <td class="text-left" v-if="currentDossierVar.classe === 'Groupage'">{{marchandise.volume}}</td>
                                                    <td v-if="avisId === 0">
                                                        <v-icon
                                                            small
                                                            @click="deleteMarchandises(marchandise)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </template>
                                        </v-simple-table>
                                        <v-simple-table dense v-else>
                                            <template v-slot:default>
                                            <thead>
                                                <tr>
                                                <th class="text-left">Rub.</th>
                                                <th class="text-left">Colis.</th>
                                                <th class="text-left">Cont.N°</th>
                                                <th class="text-left">Cont.Type</th>
                                                <th class="text-left">Description</th>
                                                <th class="text-left">Poids</th>
                                                <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="currentFactureTmp.marchandises.length > 0">
                                                <tr v-for="(marchandise,index) in currentFactureTmp.marchandises" v-bind:key="index">
                                                    <td class="text-left">{{marchandise.rub}}</td>
                                                    <td class="text-left">{{marchandise.colis}}</td>
                                                    <td class="text-left">{{marchandise.cont_numero}}</td>
                                                    <td class="text-left">{{marchandise.cont_type}}</td>
                                                    <td class="text-left">{{marchandise.description}}</td>
                                                    <td class="text-left">{{marchandise.poids}} Kg</td>
                                                    <td class="text-left">
                                                        <v-icon
                                                            small
                                                            @click="deleteMarchandises(marchandise)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="7" style="padding:10px;">Aucune donnée disponible.</td>
                                                </tr>
                                            </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                        <v-card-title style="font-size:28px;"><b>Préstations</b></v-card-title>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col md="3">
                                        <v-text-field v-model="searchPrest" append-icon="mdi-magnify" label="Rechercher une prestation.." hide-details></v-text-field>

                                        <v-treeview 
                                            style="text-align:left;"
                                            :items="items"
                                            activatable
                                            item-key="id"
                                            open-on-click
                                            :search="searchPrest"
                                        >
                                        <template slot="label" slot-scope="{ item }">
                                        <a v-if="item.name !== 'Préstations' && item.name !== 'Fret'" style="width: 100%;display: block;padding: 15px;" @click="selectPrest(item.prestation.code_prestation, prestations.length)">{{ item.name }}</a>
                                        <a v-else style="width: 100%;display: block;padding: 15px;">{{ item.name }}</a>
                                        </template>
                                        </v-treeview>
                                    </v-col>
                                    <v-col>
                                        <v-data-table
                                            hide-default-footer
                                            :headers="_headersPrestations"
                                            :items="prestations"
                                            :items-per-page=100
                                            >
                                            <template v-slot:[`item.montantTva`]="props">
                                                {{props.item.montantTva.toFixed(3)}}
                                            </template>
                                            <template v-slot:[`item.description`]="props">
                                                <v-edit-dialog
                                                :return-value.sync="props.item.description"
                                                > {{ props.item.description }}
                                                <template v-slot:input>
                                                    <v-text-field
                                                    v-model="props.item.description"
                                                    label="Edit"
                                                    persistent
                                                    counter
                                                    ></v-text-field>
                                                </template>
                                                </v-edit-dialog>
                                            </template>
                                            <template v-slot:[`item.tva`]="props">
                                                
                                                <v-edit-dialog
                                                :return-value.sync="props.item.tva"
                                                large
                                                persistent
                                                >
                                                <div>{{Number(props.item.tva).toFixed(0)}}</div>
                                                <template v-slot:[`input`]>
                                                    <div class="mt-4 title">Modifier TVA</div>
                                                </template>
                                                <template v-slot:input>
                                                    <v-text-field
                                                    v-model="props.item.tva"
                                                    label="Edit"
                                                    single-line
                                                    counter
                                                    type="number"
                                                    autofocus
                                                    ></v-text-field>
                                                </template>
                                                </v-edit-dialog>
                                            </template>

                                            <template v-slot:[`item.montant`]="props" >
                                                <template v-if="props.item.code_prestation !== '00'">
                                                    <v-edit-dialog
                                                    :return-value.sync="props.item.montant"
                                                    large
                                                    persistent
                                                    >
                                                    <div>{{Number(props.item.montant).toFixed(3)}}</div>
                                                    <template v-slot:[`input`]>
                                                        <div class="mt-4 title">Modifier Montant</div>
                                                    </template>
                                                    <template v-slot:input>
                                                        <v-text-field
                                                        v-model="props.item.montant"
                                                        label="Edit"
                                                        single-line
                                                        counter
                                                        type="Number"
                                                        autofocus
                                                        ></v-text-field>
                                                    </template>
                                                    </v-edit-dialog>
                                                </template>
                                                <template v-else>
                                                    <div>{{Number(props.item.montant).toFixed(3)}}</div>
                                                </template>
                                            </template>

                                            <template v-slot:[`item.actions`]="{ item }">
                                                <v-icon
                                                    small
                                                    @click="deletePrestation(item)"
                                                    v-if="item.code_prestation !== '00'"
                                                >
                                                    mdi-delete
                                                </v-icon>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </template>
                </v-form>
            </v-col>
            <v-col cols="12" md="3" style="position:absolute; text-align:left; right:0; background:white;">
                <v-card-title style="font-size: 36px;"><b>Total Facture</b></v-card-title>
                <span class="total-line">Total Non Taxable : <b style="float:right;">{{totalnt.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Total Taxable : <b style="float:right;">{{totalt.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Total TVA : <b style="float:right;">{{totaltva.toFixed(3)}} TND</b></span><br/>
                <!-- <span class="total-line">Timbre Fiscal :<b style="float:right;"> 0.600 TND</b></span><br/> -->
                <div class="timbre-total">
                    <v-edit-dialog
                    :return-value.sync="timbre"
                    > <span class="total-line">Timbre Fiscal :<b style="float:right;"> {{ Number(timbre).toFixed(3) }} TND</b></span><br/>
                    <template v-slot:input>
                        <v-text-field
                        v-model="timbre"
                        label="Edit"
                        persistent
                        counter
                        ></v-text-field>
                    </template>
                    </v-edit-dialog>
                </div>
                <span class="total-line">Total TTC : <b style="float:right;">{{total.toFixed(3)}} TND</b></span><br/>
            </v-col>
        </v-row>
        <v-card-title style="font-size: 36px; margin-top:115px;">
            <b>Réglement</b>
            <v-spacer></v-spacer>
            <v-switch
            v-model="reglement"
            ></v-switch>
        </v-card-title>
        <v-card-text v-if="reglement">
            <v-container fluid>
                <v-snackbar
                    style="z-index:99999;"
                    v-model="snackbar"
                    :color="snackColor"
                    right
                    top
                    >
                    {{ snackText }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                        dark
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                        >
                        Fermer
                        </v-btn>
                    </template>
                </v-snackbar>
                <v-row>
                    <v-col md="2">
                        <v-text-field
                            label="Mode Réglement"
                            outlined
                            v-model="reglementTmp.mode"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="Banque"
                            v-model="reglementTmp.banque"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="N° Pièce"
                            v-model="reglementTmp.num_piece"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-text-field
                            label="Client"
                            v-model="reglementTmp.client"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="Montant"
                            v-model="reglementTmp.montant"
                            outlined
                            type="number"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="1">
                        <v-btn color="primary" @click="setReglement" fab><v-icon>mdi-arrow-down</v-icon></v-btn>
                    </v-col>
                    <v-col md="12">
                        <v-simple-table class="text-left" dense>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">Mode Réglement</th>
                                <th class="text-left">Banque</th>
                                <th class="text-left">N° Pièce</th>
                                <th class="text-left">Client</th>
                                <th class="text-left">Montant</th>
                                <th class="text-left">Actions</th>
                                </tr>
                            </thead>
                            <tbody v-if="reglements.length > 0">
                                <tr v-for="(item, key) in reglements" v-bind:key="key">
                                    <td>{{item.mode}}</td>
                                    <td>{{item.banque}}</td>
                                    <td>{{item.num_piece}}</td>
                                    <td>{{item.client}}</td>
                                    <td>{{item.montant}} TND</td>
                                    <td>
                                        <v-icon
                                            small
                                            @click="deleteReglement(item)"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeFacture">Fermer</v-btn>
        <v-btn  style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" dark @click="addFacture">Facturer</v-btn>
        </v-card-actions>
        <v-dialog
            v-model="alertReglement"
            max-width="450"
            >
            <v-card>
                <v-card-text class="pt-5">
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-icon color="warning" style="font-size:42px;">mdi-alert</v-icon>
                        </v-col>
                        <v-col cols="12" md="10" class="text-left"><span style="font-size:18px;"> Etes vous sûre de vouloir passer cette facture sans reglements?</span></v-col>
                    </v-row>
                    
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="gray darken-1"
                    text
                    @click="checkReglement(false)"
                >
                    Annuler
                </v-btn>

                <v-btn
                    color="warning darken-1"
                    text
                    @click="checkReglement(true)"
                >
                    Accepter
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    name:'new-facture-magasinage',
    props: ['currentAvis','currentDossier'],
    data: () => ({
        currentDossierId: 0,
        avisId: 0,
        snackbar: false,
        snackText: '',
        snackColor: '',
        nb_jours: 0,
        magasinRules: [
            v => !!v || 'Ce champs est obligatoire.',
            //v => (v && (isNaN(v) || !Date.parse(v) ) ) || 'Vous devez entrer des valeurs corrects.',
        ],
        da_devise: 'TND',
        menu_enlevement: false,
        currentFactureTmp: {
            id: null,
            dossier: {},
            type_calcul: 'Poids',
            client: {},
            correspondant: {},
            agent: {},
            marchandises: []
        },
        timbre: 1,
        data: [],
        reglementHeaders: [
            { text: 'Mode Réglement', value: 'mode' },
            { text: 'Banque', value: 'banque' },
            { text: 'N° Pièce', value: 'num_piece' },
            { text: 'Client', value: 'client' },
            { text: 'Montant', value: 'montant' },
            { text: 'Actions', value: 'actions' }
        ],
        marchandiseTmp: {
            cont_type: null,
            rub: '',
            cont_numero: null,
            colis: '',
            description: '',
            poids: '',
            volume: null
        },
        headersPrestations: [
            {
            text: 'Code',
            align: 'start',
            sortable: false,
            value: 'code_prestation',
            visible : true
            },
            { text: 'Desc. prestations', value: 'description', visible: true },
            { text: 'TVA %', value: 'tva', visible: true },
            { text: 'Montant TVA', value: 'montantTva', visible: true },
            { text: 'Mnt Devise', value: 'montantDevise', visible: false },
            { text: 'Devise', value: 'devise', visible: false },
            { text: 'Cours', value: 'cour' , visible: false},
            { text: 'Montant', value: 'montant', visible: true },
            { text: 'Actions', value: 'actions', visible: true },
        ],
        listAvis: [],

        listClient: [],
        reglements: [],
        reglementTmp: {
            montant: 0,
            mode: '',
            client: '',
            num_piece: '',
            banque: ''
        },
        period1: "0",
        prix_period1:"0",
        period2: "0",
        prix_period2:"0",
        franchise: "0",
        hors_periode: "0",
        prix_hors_periode:"0",
        titreFacture: '',
        prestations: [],
        reglement: true,
        totalnt: 0,
        totalt: 0,
        setDataDialog: false,
        totaltva: 0,
        total: 0,
        todayDate: ("0"+new Date().getDate()).slice(-2)+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+new Date().getFullYear(),
        todayDateSql: new Date().getFullYear()+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+("0"+new Date().getDate()).slice(-2),
        facture: {
            global: {}
        },
        alertReglement: false,
        confirmReglement: false,
        items: [
            {
            id: 1,
            name: 'Préstations',
            children: [],
            },
            {
            id: 5,
            name: 'Fret',
            children: [],
            },
        ],
        conteneurList: [],
        dataTmp:{},
        searchPrest: '',
        correspondantList: [],
        agentList: [],
        prestationTmp: {key: 0},
        da_cour: 0,
        dossierList: [],
        typeFacture: 'Facture Standard',
        currentDossierVar: null,
        calcul_en_fc: 'Poids',
        infoRules: [
            v => !!v || 'Veuillez saisir une valeur',
        ],
        valid: false
    }),
    watch: {
        prix_period1: function(){
            this.calculprest()
        },
        prix_period2: function(){
            this.calculprest()
        },
        prix_hors_periode: function(){
            this.calculprest()
        },
        period1: function(){
            if (this.calculReste() < 0){
                this.period1 = 0
                this.snackColor = "error"
                this.snackbar = true
                this.snackText = "La durée insérée dépasse la durée totale."
            }else{
                this.hors_periode = this.calculReste()
                this.calculprest()
            }
        },

        period2: function(){
            if (this.calculReste() < 0){
                this.period2 = 0
                this.snackColor = "error"
                this.snackbar = true
                this.snackText = "La durée insérée dépasse la durée totale."
            }else{
                this.hors_periode = this.calculReste()
                this.calculprest()
            }
        },

        franchise: function(){
            if (this.calculReste() < 0){
                this.franchise = 0
                this.snackColor = "error"
                this.snackbar = true
                this.snackText = "La durée insérée dépasse la durée totale."
            }else{
                this.hors_periode = this.calculReste()
                this.calculprest()
            }
        },

        'currentFactureTmp.client_id': function(){
            if(Number(this.currentFactureTmp.client_id) > 0){
                var name = this.listClient.filter(obj => {
                    return obj.id === this.currentFactureTmp.client_id
                })[0].fullname
                this.reglementTmp.client = name
            }
        },

        timbre: function () {
            this.calculate()
        },
        currentDossierId: function(){
            if(this.currentDossierId > 0 && this.currentDossier === null){
                this.listAvis = []
                this.avisId = 0
                this.currentDossierVar = this.dossierList.filter(obj => {
                    return obj.id === this.currentDossierId
                })[0]
                this.axios
                    .get("/dossier/"+this.currentDossierId+"/avis")
                    .then(response => {
                        response.data.forEach((item, index) => {
                            this.listAvis.push(item)
                        })
                    })
            if(this.currentDossierVar.to_date.length !== 10){
                this.currentDossierVar.from_date  = this.$options.filters.formatDate(this.currentDossierVar.from_date)
                this.currentDossierVar.to_date = this.$options.filters.formatDate(this.currentDossierVar.to_date)
                //this.currentDossierVar.date_depotage = this.currentDossierVar.date_depotage
            }    
            }else if(this.currentDossier !== null){
                
            }else{
                this.avisId = 0
                this.listAvis = []
                this.prestations = []
                this.currentDossierVar = null
            }
            this.getPrestations()
        },
        avisId: function(){
            if(this.avisId > 0){
                var index = this.headersPrestations.indexOf(this.headersPrestations.filter(obj => {
                return obj.value === 'actions'})[0])
                this.headersPrestations[index].visible = true
                this.valid = true
                this.titreFacture = "Facture Magasinage"
                this.axios
                .get("/avis/single/"+this.avisId)
                .then(response => {
                    response.data.dossier.from_date  = this.$options.filters.formatDate(response.data.dossier.from_date)
                    response.data.dossier.to_date = this.$options.filters.formatDate(response.data.dossier.to_date)
                    response.data.date_depotage = response.data.dossier.date_depotage
                    this.currentFactureTmp = response.data
                    this.prestations = []
                    this.prestations.unshift({code_prestation: '00', devise:'TND', montant: 0, tva : 15, description:'MAGASINAGE'})
                    this.reglementTmp.client = response.data.client.fullname
                    this.currentFactureTmp.calcul_en_fc = 'Poids'
                    this.typeCalculChange()
                })
            }else{
                this.prestations = []
                this.valid = true
                this.titreFacture = ""
            }
        },
        prestations: {
            deep: true,
            handler: 'calculate'
        },
        /*
        data: {
            deep: true,
            handler: function(){
                if(this.typeFacture === 'Facture D/A')
                    if(this.data.filter(d => d.name === 'Devise').length)
                        this.da_devise = this.data.filter(d => d.name === 'Devise')[0].value
                    if(this.data.filter(d => d.name === 'Cours').length){
                        
                        this.da_cour = this.data.filter(d => d.name === 'Cours')[0].value   
                    }
            }
        },*/
        da_cour: function(){
            this.calculate()
        }
    },
    computed : {
        _headersPrestations () {
            return this.headersPrestations.filter(x=>x.visible)
        }
    },
    mounted(){
        this.axios
        .get('/conteneur/listing')
        .then(response => (this.conteneurList = response.data))
        
        //this.getPrestations()
        
        this.axios
            .get('/armateur/listing')
            .then(response => (this.listArmateur = response.data))
        
        this.axios
            .get('/client/listing')
            .then(response => (this.listClient = response.data))
        this.axios
            .get('/correspondant/listing')
            .then(response => (this.correspondantList = response.data))
        this.axios
            .get('/agent/listing')
            .then(response => (this.agentList = response.data))
        this.axios
            .get('/facture/listing')
            .then(response => (this.setFactureNumber(response.data)))

        this.initCurrentAvis()
        this.avisId = this.currentAvis
        this.axios
                .get("/dossier/listing")
                .then(response => (this.dossierList = response.data.filter(dossier => dossier.classe === 'Groupage')))
        if(this.currentDossier !== null){
            this.currentDossierVar = this.currentDossier
            this.currentDossierId = this.currentDossier.id
            if(this.currentDossier.to_date.length !== 10){
                this.currentDossierVar.from_date  = this.$options.filters.formatDate(this.currentDossier.from_date)
                this.currentDossierVar.to_date = this.$options.filters.formatDate(this.currentDossier.to_date)
                this.currentDossierVar.date_depotage = this.currentDossier.date_depotage
            }
            this.axios
            .get("/dossier/"+this.$route.params.id+"/avis")
            .then(response => {
                response.data.forEach((item, index) => {
                    this.listAvis.push(item)
                })
            })    
        }

        
        
        
        
    },
    methods: {
        calculprest(){
            let unit = 0
            unit = Number(this.currentFactureTmp.type_calcul_value)
            if(this.currentFactureTmp.calcul_en_fc === 'Poids'){
                unit = Math.ceil(unit/1000)*1000
            }
            this.prestations[0].montant =  
            Number(
                Number(
                    (Number(this.period1) * Number(this.prix_period1) * unit ) 
                    + (Number(this.period2) * Number(this.prix_period2) * unit) 
                    + (Number(this.hors_periode) * Number(this.prix_hors_periode) * unit)
                    )
                .toFixed(3) 
            )
        },
        typeCalculChange(){
            this.currentFactureTmp.calcul_en_fc = this.calcul_en_fc
            if(this.currentFactureTmp.calcul_en_fc === 'Poids'){
                let totalpoids = 0
                this.currentFactureTmp.marchandises.forEach((item, key) => {
                    totalpoids = totalpoids + item.poids
                })
                this.currentFactureTmp.type_calcul_value = totalpoids
            }else{
                let totalvolume = 0
                this.currentFactureTmp.marchandises.forEach((item, key) => {
                    totalvolume = totalvolume + Number(item.volume)
                })
                this.currentFactureTmp.type_calcul_value = totalvolume
            }
        },
        getPrestations(){
            this.items = [
                {
                id: 1,
                name: 'Préstations',
                children: [],
                },
                {
                id: 5,
                name: 'Fret',
                children: [],
                },
            ]
            this.prestations
            this.axios
            .get('/prestation/listing')
            .then(response => {
                    var prestList = response.data
                    function compare(a, b) {
                        // Use toUpperCase() to ignore character casing
                        const A = a.type_prestation;
                        const B = b.type_prestation;

                        let comparison = 0;
                        if (A < B) {
                            comparison = 1;
                        } else if (A > B) {
                            comparison = -1;
                        }
                        return comparison;
                    }
                    prestList.sort(compare)
                    prestList.forEach((item, index) => {
                        if(this.currentDossierVar.type === item.impoexpo){
                            //item.id = index+1
                            item.name = item.description
                            item.prestation = item
                            if(item.cour === null){
                                item.cour = 0
                            }
                            if(item.montantDevise === null){
                                item.montantDevise = 0
                            }
                            if(item.type_prestation === 'Préstation'){
                                this.items[0].children.push(item)
                            }else{
                                this.items[1].children.push(item)
                            }
                        } 
                    })
                }
            )
        },
        calculReste(){
            return Number(this.nb_jours) - (Number(this.franchise) + Number(this.period1) + Number(this.period2))
        },
        setFactureNumber(data){
            if(data.length > 0){
                var nextCode = data.reduce((max, p) => p.num_facture > max ? p.num_facture : max, data[0].num_facture)
                if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
                    nextCode = Number(nextCode)+1;
                }else{
                    nextCode = new Date().getFullYear()+'0001'
                }
                this.facture.global.num_facture = nextCode
            }else{
                this.facture.global.num_facture = new Date().getFullYear()+'0001'
            }
        },
        addMarchandise(){
            if(this.currentDossierVar === null || (this.currentDossierVar.classe !== 'Aérien' && this.currentDossierVar.classe !== 'Groupage')){
                console.log(this.conteneurList.filter(obj => {
                    return obj.titre === this.marchandiseTmp.cont_type
                })[0].id)
                this.marchandiseTmp.cont_type_id = this.conteneurList.filter(obj => {
                    return obj.titre === this.marchandiseTmp.cont_type
                })[0].id
            }
            this.currentFactureTmp.marchandises.push(this.marchandiseTmp)
            this.marchandiseTmp = {}
                        
        },
        setData(){
            this.data.push(this.dataTmp)
            this.dataTmp = {}
            this.setDataDialog = false
            console.log(this.data)
        },
        selectPrest(code, key){
            this.axios
                .get('/prestation/listing')
                .then(response => {
                    var result = response.data.filter(obj => {
                    return obj.code_prestation === code
                    })[0]
                    if(this.prestations.filter(obj => obj.code_prestation === result.code_prestation).length > 0){
                        this.snackColor = "error"
                        this.snackbar = true
                        this.snackText = "Cette préstation est déjà insérée."
                    }else{
                        if(!key)
                            key = 0
                        result.key = key+1
                        this.prestations.push(result)
                    }
                }
            )
        },
        initCurrentAvis(){
            this.currentFactureTmp = {
                id: null,
                type_calcul: 'Poids',
                dossier: {},
                client: {},
                correspondant: {},
                agent: {},
                marchandises: []
            }
        },
        initCurrentDossier(){
            this.currentDossier = {}
        },
        closeFacture(){
            this.$emit('hideDialog', true)
        },
        setReglement(){
            if(this.reglementTmp.mode === '' || this.reglementTmp.client === '' || Number(this.reglementTmp.montant) === 0){
                this.snackText = "Veuillez Remplir tous les cases obligatoires dans le règlement."
                this.snackColor = "error"
                this.snackbar = true
                console.log('problem')
            }else{
                this.reglementTmp.montant = Number(this.reglementTmp.montant).toFixed(3)
                let montant = this.reglementTmp.montant
                this.reglements.forEach((item,index) => {
                    montant = Number(Number(montant) + Number(Number(item.montant).toFixed(3)))
                })
                if(montant > Number(this.total.toFixed(3))){
                    this.snackText = "Le montant total des règlements ne doit pas dépasser le montant total de la facture."
                    this.snackColor = "error"
                    this.snackbar = true
                }else{
                    this.reglements.push(this.reglementTmp)
                    this.reglementTmp = {
                        montant: 0,
                        mode: '',
                        client: '',
                        num_piece: '',
                        banque: ''
                    }
                }
            }
            
        },
        calculate(){
            this.totalnt = 0
            this.totalt = 0
            this.totaltva = 0
            this.total = 0
            this.prestations.forEach((item , index) => {
                item.cour = Number(item.cour)
                item.montant = Number(item.montant)
                item.montantDevise = Number(item.montantDevise)
                item.tva = Number(item.tva)
                if(item.cour > 0){
                    this.prestations[index].montant = item.cour * item.montantDevise
                } 
                if(item.tva === 0){
                    this.totalnt = item.montant + this.totalnt
                }else{
                    this.totaltva = item.montant * item.tva / 100  + this.totaltva
                    this.totalt = item.montant + this.totalt
                }
                item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
            })
            this.total =  Number(this.total.toFixed(3)) + Number(this.totalnt.toFixed(3)) + Number(this.totalt.toFixed(3)) + Number(this.totaltva.toFixed(3)) + Number(Number(this.timbre).toFixed(3))
            this.reglementTmp.montant = this.total.toFixed(3)
        
            
        },
        addFacture(){
            if(this.valid !== true){
                this.snackColor = "error"
                this.snackText = "Essayez de remplir tous les champs obligatoires."
                this.snackbar = true
            }else{
                if(this.reglements.length === 0 && this.confirmReglement === false){
                    this.alertReglement = true
                }else{
                    this.facture.data = []
                    this.facture.global.dossier_id = Number(this.currentDossierId)
                    this.facture.reglements = this.reglements
                    this.facture.global.libelle = this.titreFacture
                    this.facture.global.date = this.todayDateSql
                    this.facture.global.avis_id = Number(this.avisId)
                    this.facture.global.client_id = 0
                    this.facture.global.is_da = 0
                    this.facture.prestations = []
                    this.facture.marchandises = []
                    this.facture.global.is_magasinage = 1
                    this.facture.global.is_surestarie = 0
                    this.facture.global.timbre = Number(this.timbre)
                    this.prestations.forEach((item, index) => {
                        let prestTmp = Object.assign({}, {...item})
                        delete prestTmp.key
                        delete prestTmp.id
                        delete prestTmp.montantTva
                        delete prestTmp.datetime
                        this.facture.prestations[index] = prestTmp
                    })
                    this.currentFactureTmp.marchandises.forEach((item, index) => {
                        delete item.id
                        delete item.cont_type
                        delete item.avis_id
                        this.facture.marchandises[index] = item
                    })
                    this.facture.data = [
                        {'name': 'date_enlevement', value: this.currentFactureTmp.date_enlevement},
                        {'name': 'franchise', value: this.franchise},
                        {'name': 'calcul_en_fc', value: this.currentFactureTmp.calcul_en_fc},
                        {'name': 'calcul_valeur', value: this.currentFactureTmp.type_calcul_value},
                        {'name': 'nb_jours', value: this.nb_jours},
                        {'name': 'period1', value: this.period1},
                        {'name': 'period2', value: this.period2},
                        {'name': 'hors_periode', value: this.hors_periode},
                        {'name': 'prix_period1', value: this.prix_period1},
                        {'name': 'prix_period2', value: this.prix_period2},
                        {'name': 'prix_hors_period', value: this.prix_hors_periode},
                    ]
                    //this.facture.prestations = this.prestations
                    //this.facture.marchandises = this.currentFactureTmp.marchandises
                    this.axios.post('/facture/create', this.facture, {}).then((res) => {
                    if(res.data === 'error'){
                        this.snackColor = "error"
                        this.snackText = "Essayez de remplir tous les champs obligatoires."
                        this.snackbar = true
                        }else{
                        this.snackColor = "success"
                        this.snackText = "La facture a été ajoutée avec succès."
                        this.snackbar = true
                        this.$emit('reloadData')
                        this.$emit('hideDialog', true)
                        }
                    }).catch(e => {
                        this.snackColor = "error"
                        this.snackbar = true
                        this.snackText = "Un erreur est survenu, essayez plus tard."
                        console.log(e)
                    })
                }
            }
            
        },
        setPrestation(){
            if(this.prestationTmp.montantDevise > 0){
                this.prestationTmp.montant = Number(Number(this.prestationTmp.montantDevise).toFixed(3)) * Number(Number(this.da_cour).toFixed(3))
            }else{
                this.prestationTmp.montantDevise = Number ( Number(Number(this.prestationTmp.montant).toFixed(3)) / Number(Number(this.da_cour).toFixed(3)) ).toFixed(3)
            }
            this.prestationTmp.cour = this.da_cour
            this.prestations.push(this.prestationTmp)
            this.prestationTmp = {key: this.prestationTmp.key+1}
            
        },
        change_jrs(){
            /*var dateString = this.currentDossier.date_depotage
            var dateParts = dateString.split("/")
            //var date2 = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])*/
            var date1 = new Date(this.currentFactureTmp.date_enlevement)
            var date2 = new Date(this.currentFactureTmp.date_depotage)
            this.nb_jours = parseInt((date1 - date2) / (1000 * 3600 * 24))
            this.hors_periode = this.calculReste()
        },
        deleteReglement(item){
            const index = this.reglements.indexOf(item)
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.reglements.splice(index, 1)
        },
        deleteMarchandises (item) {
            const index = this.currentFactureTmp.marchandises.indexOf(item)
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.currentFactureTmp.marchandises.splice(index, 1)
        },
        deleteData(item){
            const index = this.data.indexOf(item)
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.data.splice(index, 1)
        },
        deletePrestation (item) {
            const index = this.prestations.indexOf(item)
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.prestations.splice(index, 1)
        },
        checkReglement(value){
            if(value === true){
                this.confirmReglement = true
                this.addFacture()
            }
            this.alertReglement = false
            
        }
    }
}
</script>
<style scoped>
.total-prices span{
    font-size: 16px;
    display: block;
    line-height: 9px;
}
.total-line{
    line-height: 45px;
    font-size: 18px;
    padding-left: 15px;
}
.timbre-total >>> .v-small-dialog__activator__content {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/facture/magasinage/new.component.vue